import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] h-screen overflow-y-auto p-5" }
const _hoisted_2 = { class: "p-3 bg-[#2B2C32] border-0 rounded-lg" }
const _hoisted_3 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]"
}
const _hoisted_4 = { class: "text-[24px] text-white font-semibold mb-3 flex justify-between" }
const _hoisted_5 = { class: "py-2 grid gap-4 xl:grid-cols-4 grid-cols-1" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "input-wrapper" }
const _hoisted_8 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 py-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.vg_selectedLocation.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_block_loading)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Settings ", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ( _ctx.createLocationLot())),
                      class: "text-sm font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-white hover:text-white hover:bg-theme-darkgreen"
                    }, "SAVE")
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass('input-wrapper ' + (_ctx.form.cannabisWeightLimit.error_type))
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        class: "block text-white text-xs mb-1",
                        for: "company"
                      }, "Cannabis limit", -1)),
                      _withDirectives(_createElementVNode("input", {
                        onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['cannabisWeightLimit']))),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.cannabisWeightLimit.value) = $event)),
                        class: "appearance-none rounded w-full py-2.5 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline text-sm",
                        placeholder: "Cannabis Limit",
                        type: "number"
                      }, null, 544), [
                        [_vModelText, _ctx.form.cannabisWeightLimit.value]
                      ]),
                      (_ctx.form.cannabisWeightLimit.error_message)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "field-error label-text mt-1",
                            textContent: _toDisplayString(_ctx.form.cannabisWeightLimit.error_message)
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        class: "block text-white text-xs mb-2",
                        for: "company"
                      }, "Lot tracking", -1)),
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.form.lotTracking = !_ctx.form.lotTracking), ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.lotTracking) = $event)),
                          class: "hidden peer"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.lotTracking]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.lotTracking ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                        }, null, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.lotTracking ? 'text-theme-green' : 'text-[#F53333]'])
                        }, _toDisplayString(_ctx.form.lotTracking ? 'On' : 'Off'), 3)
                      ])
                    ])
                  ])
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.", -1)
          ]))]))
    ])
  ]))
}